<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
          <v-autocomplete
            :items="searchSelect"
            v-model="searchType"
            menu-props="auto"
            label="Year"
            hide-details
            solo
            @change="searchYear"
          ></v-autocomplete>
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Purchase Orders</span><br />
        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :isLoading=this.isTableLoading
        :columns="columns"
        :rows="rows"
        @on-cell-click="onCellClick"
        :search-options="{
          enabled: true
        }">
        <template slot="loadingContent">
          <div>
            <v-progress-circular
              :size="50"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'id'">
            <strong>{{ currentYear }}-{{props.row.id}}</strong>
          </span>
          <span v-else-if="props.column.field == 'amount'">
            {{ props.row.amount | currency }}
          </span>
          <div v-else-if="props.column.field == 'actions'" class="text-xs-center">
            <v-avatar
              v-if="props.row.chairmanApproval === 'No'"
              color="red lighten-4"
              class="mr-2 mt-2"
              size="30"
            >
              <v-icon small>close</v-icon>
            </v-avatar>
            <v-avatar
              v-else
              color="green"
              class="mr-2 mt-2"
              size="30"
            >
              <v-icon small>check</v-icon>
            </v-avatar>
          </div>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="newItem()"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Purchase Order</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn  v-if="isApproved" depressed color="error" @click="disApproveItem">Disapprove</v-btn>
            <v-btn  v-else-if="canApprove" depressed color="success" @click="approveItem">Approve</v-btn>

            <v-btn v-if="editedItem.id > 0" dark flat @click="updateItem">Update</v-btn>
            <v-btn v-else dark flat @click="addItem">Save</v-btn>

            <v-menu offset-y>
            <v-btn slot="activator" icon dark>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile v-if="editedItem.id > 0" @click="download">
                <v-list-tile-action>
                <v-icon>print</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Print</v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile @click.stop="editItem">
                <v-list-tile-action>
                <v-icon>build</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Test</v-list-tile-title>
              </v-list-tile> -->
            </v-list>
          </v-menu>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12 class="text-xs-right">
                <p class="subheading font-weight-black">{{ editedItem.approvedBy }}</p>
              </v-flex>
              <v-flex xs6>
                PO Number: {{ currentYear }}-{{ editedItem.id }}
              </v-flex>
              <v-flex xs6>
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="editedItem.date"
                    label="Date"
                    @blur="date1 = parseDate(editedItem.date)"
                  ></v-text-field>
                  <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.payee"
                  @keyup.enter="save"
                  label="Payee"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.address"
                  @keyup.enter="save"
                  label="Address"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs10 md5>
                    <v-text-field
                      v-model="editedItem.city"
                      @keyup.enter="save"
                      label="City"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 md2>
                    <v-text-field
                      v-model="editedItem.state"
                      @keyup.enter="save"
                      label="ST"
                      mask="AA"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="editedItem.zip"
                      @keyup.enter="save"
                      label="Zipcode"
                      mask="#####"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="editedItem.phone"
                  @keyup.enter="save"
                  label="Phone"
                  mask="(###) ###-####"
                  return-masked-value
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8>
                <v-text-field
                  v-model="editedItem.email"
                  @keyup.enter="save"
                  label="Email Address"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pt-4 class="text-xs-center text-sm-left">
                <span class="title">Purchase Information</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.amount"
                  @keyup.enter="save"
                  label="Amount"
                  type="number"
                  prefix="$"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="editedItem.dueDate"
                    label="Due Date"
                    @blur="date2 = parseDate(editedItem.dueDate)"
                  ></v-text-field>
                  <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.description"
                  label="Description"
                  counter
                  maxlength="200"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 pt-4 class="text-xs-center text-sm-left">
                <span class="title">Accounting and Approval</span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="chartAccounts"
                  item-text="fullName"
                  item-value="id"
                  v-model="editedItem.ChartAccountId"
                  label="Chart Of Accounts"
                  hide-details
                  outline
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="committeeList"
                  item-text="text"
                  item-value="value"
                  v-model="editedItem.CommitteeId"
                  label="Committee"
                  hide-details
                  outline
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <a :href="editedItem.filePath" target="_blank">{{ editedItem.files }}</a>
              </v-flex>
              <v-flex xs12>
                <v-btn color="blue darken-1" flat v-on:click="addFiles()">
                  <v-icon left dark>mdi-paperclip</v-icon>
                  Add Attachments
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <label>
                  <input type="file" id="files" ref="files" multiple v-on:change="handleFileUploads"/>
                </label>
              </v-flex>
              <v-flex xs12>
                <v-list two-line subheader>
                  <v-subheader v-if="files.length > 0" inset>Files</v-subheader>
                  <v-divider v-if="files.length > 0"></v-divider>
                  <template v-for="(file, index) in files">
                    <v-list-tile avatar :key="index">
                      <v-list-tile-avatar>
                        <v-icon
                          v-if="file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/excel' || file.type === 'text/csv'"
                          color="green darken-2"
                          large
                        >
                          mdi-file-excel
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword'"
                          color="blue darken-2"
                          large
                        >
                          mdi-file-word
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'image/png' || file.type === 'image/jpeg'"
                          color="yellow darken-2"
                          large
                        >
                          mdi-file-image
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/pdf'"
                          color="red darken-2"
                          large
                        >
                          mdi-file-pdf
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/zip'"
                          color="orange darken-2"
                          large
                        >
                          mdi-zip-box
                        </v-icon>
                        <v-icon
                          v-else
                          color="gray darken-2"
                          large
                        >
                          mdi-file-document-box
                        </v-icon>
                      </v-list-tile-avatar>

                      <v-list-tile-content inset>
                        <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ file.lastModified }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon v-on:click="removeFile( index )" color="red">block</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="file.name"></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn  v-if="canApprove" depressed color="success" @click="approveItem">Approve</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
// import imageExists from 'image-exists'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-croppa/dist/vue-croppa.css'
import EmailForm from './forms/EmailForm'
import XLSX from 'xlsx'
var pdfMake = require('pdfmake/build/pdfmake.js')
var pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  components: {
    VueGoodTable,
    EmailForm
  },
  data () {
    return {
      myId: this.$store.state.user.id,
      logo: '',
      searchSelect: [],
      searchType: '',
      currentYear: 0,
      isChair: false,
      canApprove: false,
      isApproved: false,
      dialog: false,
      croppa: {},
      size: 250,
      initialImage: null,
      dataURL: '',
      loading: false,
      isTableLoading: false,
      poNumber: 'New',
      date1: null,
      menu1: false,
      date2: null,
      menu2: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      chartAccounts: [],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'PO #',
          field: 'id',
          thClass: 'text-center',
          html: true,
          width: '110px'
        },
        {
          label: 'Payee',
          field: 'payee',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Description',
          field: 'description',
          thClass: 'hidden-sm-and-down email-width text-center',
          tdClass: 'hidden-sm-and-down email-width',
          type: 'text'
        },
        {
          label: 'Committee',
          field: 'Committee.name',
          thClass: 'hidden-sm-and-down email-width text-center',
          tdClass: 'hidden-sm-and-down email-width',
          html: true
        },
        {
          label: 'Due Date',
          field: 'dueDate',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text',
          width: '120px'
        },
        {
          label: 'Amount',
          field: 'amount',
          thClass: 'hidden-sm-and-down text-right',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      exportFields: {
        'id': 'id',
        'Name': 'name',
        'Image': 'image',
        'Picture': 'picture',
        'Image File': 'imageFile',
        'Data Url': 'dataUrl',
        'Diet': 'diet',
        'Count': 'count'
      },
      editedItem: {
        index: 0,
        id: 'New',
        date: '',
        payee: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: '',
        phone: '',
        amount: '',
        dueDate: '',
        description: '',
        ChartAccountId: 0,
        CommitteeId: 0,
        UserId: 0,
        chairmanApproval: 'No'
      },
      defaultItem: {
        index: 0,
        id: 'New',
        date: '',
        payee: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: '',
        phone: '',
        amount: '',
        dueDate: '',
        description: '',
        ChartAccountId: 0,
        CommitteeId: 0,
        UserId: 0,
        chairmanApproval: 'No'
      },
      liason: {},
      showEmailForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      purchaseOrders: {},
      committeeList: [],
      files: []
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.yearList()

    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getLogo()
    this.getPos()
    this.getCharts()
    this.getCommittees()
    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    user () {
      return this.$store.state.user
    },

    isAdmin () {
      return this.$store.state.isAdmin
    },

    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    '$route.params.committee': function (committee) {
      this.isTableLoading = true
      this.loading = true

      this.getPos()
      this.loading = false
    },

    date1 (val) {
      this.editedItem.date = this.formatDate(this.date1)
    },

    date2 (val) {
      this.editedItem.dueDate = this.formatDate(this.date2)
    },

    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    async getLogo () {
      const response = await Api().get('get_logo')
      this.logo = response.data
    },

    addFiles () {
      this.$refs.files.click()
    },

    handleFileUploads (e) {
      let uploadedFiles = e.target.files

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },

    removeFile (key) {
      this.files.splice(key, 1)
    },

    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        let yearItem = {
          text: i,
          value: i
        }

        this.searchSelect.push(yearItem)
      }
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.editedItem.image = files[0].name

        if (this.editedItem.image.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])

        fr.addEventListener('load', () => {
          this.editedItem.picture = fr.result
          this.editedItem.imageFile = files[0]
        })
      } else {
        this.editedItem.image = ''
        this.editedItem.imageFile = ''
        this.editedItem.picture = ''
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    async onCellClick (params) {
      // console.log(this.user.id)
      // console.log(params.row.CommitteeId)
      try {
        this.getChair(params.row.CommitteeId)

        const response = await Api().get('is_chair/' + this.user.id + '/' + params.row.CommitteeId)

        let chair = response.data.status

        if (chair !== null) {
          this.canApprove = true
        } else if (this.isAdmin) {
          this.canApprove = true
        } else {
          this.canApprove = false
        }

        this.editedItem.index = params.row.originalIndex
        this.editedItem.id = params.row.id
        this.editedItem.date = this.formatDate(params.row.date)
        this.editedItem.payee = params.row.payee
        this.editedItem.email = params.row.email
        this.editedItem.address = params.row.address
        this.editedItem.city = params.row.city
        this.editedItem.state = params.row.state
        this.editedItem.zip = params.row.zip
        this.editedItem.email = params.row.email
        this.editedItem.phone = params.row.phone
        this.editedItem.amount = params.row.amount
        this.editedItem.dueDate = this.formatDate(params.row.dueDate)
        this.editedItem.description = params.row.description
        this.editedItem.ChartAccountId = params.row.ChartAccountId
        this.editedItem.CommitteeId = params.row.CommitteeId
        this.editedItem.chairmanApproval = params.row.chairmanApproval
        this.editedItem.files = params.row.files
        this.editedItem.filePath = process.env.API_URL + '/attachments/' + params.row.files

        if (this.editedItem.chairmanApproval === 'Yes' && this.canApprove === true) {
          this.isApproved = true
        } else {
          this.isApproved = false
        }

        // console.log('isApproved', this.isApproved)
        if (params.row.approvedBy) {
          const responsea = await Api().get('users/' + params.row.approvedBy)
          this.editedItem.approvedBy = 'Approved By ' + responsea.data.fullName
        } else {
          this.editedItem.approvedBy = ' '
        }

        this.dialog = true

        // params.row - row object
        // params.column - column object
        // params.rowIndex - index of this row on the current page.
        // params.event - click event
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getChair (committeeId) {
      try {
        const response = await Api().get('is_chair/' + this.user.id + '/' + committeeId)
        console.log(response)
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {

      // console.log(this.evalItem)
      // this.showEvalForm = true
      // let image = new Image()
      // image.setAttribute('crossorigin', 'anonymous')
      // image.src = props.row.picture

      // this.initialImage = image
      // this.croppa.refresh()

      // this.editedIndex = props.index
      // this.editedItem.id = props.row.id
      // this.editedItem.name = props.formattedRow.name
      // this.editedItem.diet = props.formattedRow.diet
      // this.editedItem.count = props.formattedRow.count
      // this.editedItem.image = props.row.image
      // this.editedItem.picture = props.row.picture
      // this.dialog = true
    },

    save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
      // console.log(this.editedItem.dataUrl)

      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
        this.rows.push(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    async getPos () {
      try {
        const response = await Api().get('purchase_orders/' + this.currentYear)

        this.rows = response.data
        // console.log(this.rows)

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getCharts () {
      try {
        const response = await Api().get('chart_accounts')
        this.chartAccounts = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getCommittees () {
      try {
        const response = await Api().get('get_committeespo/' + this.currentYear)
        // console.log('committees', response.data)
        this.committeeList = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getPos()
      this.getCommittees()
    },

    async addItem (item) {
      let filenames = []

      let formData = new FormData()
      formData.append('date', this.editedItem.date)
      formData.append('payee', this.editedItem.payee)
      formData.append('address', this.editedItem.address)
      formData.append('city', this.editedItem.city)
      formData.append('state', this.editedItem.state)
      formData.append('zip', this.editedItem.zip)
      formData.append('email', this.editedItem.email)
      formData.append('phone', this.editedItem.phone)
      formData.append('amount', this.editedItem.amount)
      formData.append('dueDate', this.editedItem.dueDate)
      formData.append('description', this.editedItem.description)
      formData.append('ChartAccountId', this.editedItem.ChartAccountId)
      formData.append('CommitteeId', this.editedItem.CommitteeId)
      formData.append('UserId', this.myId)
      formData.append('year', this.currentYear)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        // console.log(this.files[i])
        filenames.push(this.files[i].name)
      }
      formData.append('files', filenames)

      try {
        const response = await Api().post('purchase_orders', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      let filenames = []

      let formData = new FormData()
      formData.append('date', this.editedItem.date)
      formData.append('payee', this.editedItem.payee)
      formData.append('address', this.editedItem.address)
      formData.append('city', this.editedItem.city)
      formData.append('state', this.editedItem.state)
      formData.append('zip', this.editedItem.zip)
      formData.append('email', this.editedItem.email)
      formData.append('phone', this.editedItem.phone)
      formData.append('amount', this.editedItem.amount)
      formData.append('dueDate', this.editedItem.dueDate)
      formData.append('description', this.editedItem.description)
      formData.append('ChartAccountId', this.editedItem.ChartAccountId)
      formData.append('CommitteeId', this.editedItem.CommitteeId)
      formData.append('UserId', this.myId)
      formData.append('year', this.currentYear)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        // console.log(this.files[i])
        filenames.push(this.files[i].name)
      }
      formData.append('files', filenames)

      try {
        const response = await Api().put('purchase_orders/' + this.editedItem.id, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeItem (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].name + ' <' + this.rows[i].email + '>'
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].name + ' <' + this.$refs['my-table'].selectedRows[i].email + '>'
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    onExport () {
      // console.log(this.rows)
      this.printMembers = this.rows.map(a => ({
        'First Name': a.firstName,
        'Last Name': a.lastName,
        'Title': a.title,
        'Email': a.email,
        'Mobile': a.cellPhone
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeName)

      XLSX.writeFile(wb, 'committee.xlsx')
    },

    async approveItem () {
      try {
        let approvalForm = {}

        approvalForm.userId = this.user.id
        approvalForm.poId = this.editedItem.id
        approvalForm.status = 'Yes'
        const response = await Api().post('add_approval', approvalForm)

        this.isApproved = true

        // let rowItem = this.rows[this.editedItem.index]
        // console.log(rowItem)
        this.rows[this.editedItem.index].chairmanApproval = 'Yes'
        this.rows[this.editedItem.index].approvedBy = this.user.id

        // let name = this.titleList.find(item => item.value === this.editedTitle.TitleId)
        // this.editedTitle.name = name.text
        // this.editedTitle.id = response.data.title.id

        // this.userTitles.push(this.editedTitle)

        // setTimeout(() => {
        //   this.editedTitle = Object.assign({}, this.defaultTitle)
        //   this.formattedTitleDate = ''
        // }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async disApproveItem () {
      try {
        let approvalForm = {}

        approvalForm.userId = 0
        approvalForm.poId = this.editedItem.id
        approvalForm.status = 'No'
        const response = await Api().post('add_approval', approvalForm)

        this.isApproved = false

        this.rows[this.editedItem.index].chairmanApproval = 'No'
        this.rows[this.editedItem.index].approvedBy = 0

        // let name = this.titleList.find(item => item.value === this.editedTitle.TitleId)
        // this.editedTitle.name = name.text
        // this.editedTitle.id = response.data.title.id

        // this.userTitles.push(this.editedTitle)

        // setTimeout(() => {
        //   this.editedTitle = Object.assign({}, this.defaultTitle)
        //   this.formattedTitleDate = ''
        // }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    remove (item) {
      // console.log(item)
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    closeThis (item) {
      // console.log('test')
      this.emails = []
      this.showEmailForm = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.showEmailForm = false
      this.editedItem = this.defaultItem

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    download () {
      let committee = this._.find(this.committeeList, ['value', this.editedItem.CommitteeId])
      let chart = this._.find(this.chartAccounts, ['id', this.editedItem.ChartAccountId])

      let docDefinition = {
        // footer: function (currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount },
        content: [
          {
            image: 'data:image/jpeg;base64,' + this.logo,
            width: 150,
            alignment: 'center'
          },

          { text: 'RENO RODEO PURCHASE ORDER', style: 'header' },

          {
            columns: [
              {
                width: '50%',
                bold: true,
                text: 'PO Number: ' + this.currentYear + '-' + this.editedItem.id
              },
              {
                width: '50%',
                alignment: 'right',
                bold: true,
                text: 'Date: ' + this.editedItem.date
              }
            ],
            margin: [ 0, 0, 0, 10 ]
          },

          { text: 'PAYEE INFORMATION', alignment: 'center', bold: true, margin: [ 0, 10, 0, 10 ] },

          {
            columns: [
              { text: 'Name:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.payee, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Address:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.address, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'City:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.city, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              },
              { text: 'State:', width: '10%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ 30 ],

                  body: [
                    [ { text: this.editedItem.state, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              },
              { text: 'Zip:', width: '10%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.zip, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Phone:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.phone, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Email:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.email, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          { text: 'PURCHASE INFORMATION', alignment: 'center', bold: true, margin: [ 0, 15, 0, 10 ] },

          {
            columns: [
              { text: 'Amount:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: '$' + this.editedItem.amount, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              },
              { text: 'Date Due:', width: '30%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.dueDate, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Description:', width: '15%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.description, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          { text: 'ACCOUNTING AND APPROVAL', alignment: 'center', bold: true, margin: [ 0, 15, 0, 10 ] },

          {
            columns: [
              { text: 'Chart of Accounts:', width: '25%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: chart.fullName, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Committee:', width: '25%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: committee.text, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          },

          {
            columns: [
              { text: 'Chair-Approval:', width: '25%', alignment: 'right', margin: [ 0, 0, 5, 0 ] },
              {
                layout: 'lightHorizontalLines', // optional
                table: {
                  widths: [ '*' ],

                  body: [
                    [ { text: this.editedItem.approvedBy, margin: [ 5, 0, 0, 0 ] } ],
                    [ ' ' ]
                  ]
                }
              }
            ]
          }
        ],

        styles: {
          header: {
            fontSize: 14,
            bold: true,
            alignment: 'center',
            margin: [ 0, 10, 0, 10 ]
          }
        }
      }

      pdfMake.createPdf(docDefinition).download(this.currentYear + '-' + this.editedItem.id + '.pdf')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseOrders.vue